import TrailsIcon from "./TrailsIcon";

// When we add more arrows, change this to named exports
export default TrailsIcon;
